export default __webpack_public_path__ + "static/media/dart.d19523f9.svg";